import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from './cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, error, hint, className, id, ...props },
  ref,
) {
  const tid = id ?? props.name ?? `ta-${Math.random().toString(36).slice(2)}`;
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={tid} className="mb-1 block text-sm font-medium text-stitch-fg-soft">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        id={tid}
        className={cn(
          'block w-full rounded-stitch-lg border border-stitch-border bg-stitch-surface px-3 py-2 text-base text-stitch-fg shadow-sm placeholder:text-stitch-muted sm:text-sm',
          'transition-colors duration-stitch ease-stitch-out',
          'focus:border-stitch-primary focus:outline-none focus:ring-2 focus:ring-stitch-ring focus:ring-offset-2 focus:ring-offset-stitch-canvas',
          error && 'border-stitch-danger focus:border-stitch-danger focus:ring-stitch-danger',
          className,
        )}
        aria-invalid={error ? true : undefined}
        {...props}
      />
      {hint && !error && (
        <p className="mt-1 text-xs text-stitch-muted">{hint}</p>
      )}
      {error && (
        <p className="mt-1 text-sm text-stitch-danger" role="alert">
          {error}
        </p>
      )}
    </div>
  );
});
